'use strict';

jQuery.noConflict();

jQuery( document ).ready( function( $ ) {

	var siteInit = {

		DOMready: function() {

			if ( $('.js-slider--primary').length > 0 ) {
				siteInit.slider();
			}

			if ( $('.mediaGalleryBrowser').length > 0 ) {
				//siteInit.gallery();
			}

			if ( $('.js-carousel').length > 0 ) {
				siteInit.carousel();
			}

			if ( $('[href$=".jpg"], [href$=".png"], [href$=".gif"]').length > 0 ) {
				siteInit.modal();
			}

			if ( $('.js-navicon').length > 0 ) {
				siteInit.mobileNavigation();
			}

			if ( $('.js-search-toggle').length > 0 ) {
				siteInit.searchForm();
			}

			if ( $('.js-form-toggle').length > 0 ) {
				siteInit.formToggle();
			}

			if ( $('.js-menu-toggle').length > 0 ) {
				siteInit.menuToggle();
			}

			if ( $('.js-select-list').length > 0 ) {
				siteInit.selectList();
			}

			if ( $('.news--preview').length > 0 ) {
				siteInit.infiniteNews();
			}

			if ( $('.product').length > 0 ) {
				siteInit.infiniteCatalogs();
			}

			// if ( $('.js-popup').length > 0 ) {
			// 	siteInit.popUp();
			// }

		},

		// Slider
		slider: function() {

			var owl = $('.js-slider--primary');

			owl.on('initialized.owl.carousel', function(event) {

				 var currentItem = event.item.index;
				  console.log("init: " + currentItem);
        		//window.location.hash = currentItem + 1;
				//location.hash = 'slide' + event.item.index;
				activeClass(currentItem);

			});

			owl.on('changed.owl.carousel', function(event) {

				//console.log(event);
				var currentItem = event.item.index;
				console.log("change: " + currentItem);
        		//window.location.hash = currentItem + 1;

				//location.hash = 'slide' + event.item.index;
				activeClass(currentItem);

			});

			function activeClass(position) {

				console.log('Posizione: ' + position);

				$( ".banner--primary" ).each(function( index ) {

					$(this).removeClass('is-active');

					if (index === position ) {
						console.log(this);
						$(this).addClass('is-active');
					}

				});
			}

			owl.owlCarousel({
				items: 1,
				loop:false,
				autoplay: true,
				URLhashListener:true,
				autoplayHoverPause:true
			});

		},


		popUp: function () {

			$('.js-popup').showElement({
	     		hideClass: 'popup--hidden'
			});

		},

		// Carousel
		carousel: function() {

			$(".js-carousel").owlCarousel({
				margin:20,
				loop:true,
				nav:true,
				responsive : {
					0 : {
						items: 1,
						nav:false
					},
					480 : {
						items: 2,
						nav:false
					},
					768 : {
						items: 4,
						nav:true
					} // 992
				}

			});

		},

		// Modal
		modal: function() {

			$('[href$=".jpg"], [href$=".png"], [href$=".gif"]').colorbox({
				transition: 'elastic',
				speed: 400,
				opacity: 0.8,
				slideshow: false,
				slideshowSpeed: 4000,
				itemsnitialWidth: 50,
				initialHeight: 50,
				maxWidth: '90%',
				maxHeight: '90%',
			});

		},

		// Mobile navigation
		mobileNavigation: function() {

			$('body').on( 'click', '.js-navicon', function( event ) {

				var $el = $(this).add('#navigation');
				$( $el ).toggleClass('is-active');
				$( '.navigation--primary' ).toggleClass('is-open');

				event.preventDefault();

			});

		},

		// Search
		searchForm: function() {

			$(".js-search-toggle").on('click', function() {
				$(".search").toggleClass('is-active');
			});

		},


		// Gallery
		gallery: function() {

			$(".mediaGalleryBrowser").lightGallery();

		},

		// Form
		formToggle: function() {

			$(".js-form-toggle").on('click', function(e) {
				e.preventDefault();
				$("#form").slideToggle();
			});

		},

		// Side menu toggle
		menuToggle: function() {

			$(".js-menu-toggle").on('click', function(e) {
				e.preventDefault();
				$(this).toggleClass('is-open');
				$(".expCatalogueCategory1").toggleClass('is-open');

			});

		},

		// Select list
		selectList: function() {

			$(".js-select-grid").on('click', function() {
				$(this).addClass('is-active');
				$(".js-select-list").removeClass('is-active');
				$(".page__content").removeClass('is-list');
			});

			$(".js-select-list").on('click', function() {
				$(this).addClass('is-active');
				$(".js-select-grid").removeClass('is-active');
				$(".page__content").addClass('is-list');
			});

		},

		infiniteNews: function() {
			var ias = jQuery.ias({
				container: '.LargeBoxContainer',
				item: '.news--preview',
				pagination: '.NavigationBar',
				next: '.NavigationAutoLink[title="Successivo"]'
			});

			//ias.extension(new IASSpinnerExtension());
			ias.extension(new IASTriggerExtension({
				offset: 2,
				text: "Carica altri articoli",
				html: '<div class="infinite centered"><button class="button button--primary button--pill">{text}</button></div>',
			}));

			ias.extension(new IASSpinnerExtension({
				//src: pathBase + 'content/img/loading.gif',
				html: '<div class="infinite centered"><img src="{src}"/></div>'
			}));
		},

		infiniteCatalogs: function() {

			var ias = jQuery.ias({
				container: '.product-container',
				item: '.product',
				pagination: '.pager',
				next: '.pager li:last-child a'
			});

			//ias.extension(new IASSpinnerExtension());
			ias.extension(new IASTriggerExtension({
				offset: 2,
				text: "Carica altri prodotti",
				html: '<div class="infinite centered"><button class="button button--primary button--pill">{text}</button></div>',
			}));

			ias.extension(new IASSpinnerExtension({
				//src: pathBase + 'content/img/loading.gif',
				html: '<div class="infinite centered"><img src="{src}"/></div>'
			}));
		}

	};

	siteInit.DOMready();

});
